import { signInWithEmailAndPassword, signOut } from "firebase/auth"
import { auth } from "@/lib/firebase"

export const loginWithEmailAndPassword = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      password
    )
    const token = await userCredential.user.getIdToken()

    return {
      user: {
        email: userCredential.user.email,
        uid: userCredential.user.uid,
        displayName:
          userCredential.user.displayName ||
          userCredential.user.email.split("@")[0],
        photoURL: userCredential.user.photoURL,
      },
      token,
    }
  } catch (error) {
    let errorMessage = "Failed to login"

    // Handle Firebase Auth Error Codes
    if (
      error.code === "auth/invalid-credential" ||
      error.code === "auth/user-not-found"
    ) {
      errorMessage = "Email not found or invalid credentials"
    } else if (error.code === "auth/wrong-password") {
      errorMessage = "Invalid password"
    } else if (error.code === "auth/invalid-email") {
      errorMessage = "Invalid email format"
    } else if (error.code === "auth/user-disabled") {
      errorMessage = "This account has been disabled"
    } else if (error.code === "auth/too-many-requests") {
      errorMessage = "Too many failed attempts. Please try again later"
    } else if (error.code === "auth/network-request-failed") {
      errorMessage = "Network error. Please check your connection"
    }

    // If there are specific error messages in the response
    if (error.errors && Array.isArray(error.errors)) {
      const serverMessage = error.errors[0]?.message
      if (serverMessage === "EMAIL_NOT_FOUND") {
        errorMessage = "Email address not found"
      }
    }

    throw new Error(errorMessage)
  }
}

export const logoutUser = async () => {
  try {
    await signOut(auth)
  } catch (error) {
    throw new Error("Failed to logout")
  }
}

export const resetPassword = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email)
  } catch (error) {
    throw new Error(error.message)
  }
}
